import { render } from "./DeliveryAreas.vue?vue&type=template&id=b5516b58"
import script from "./DeliveryAreas.vue?vue&type=script&lang=js"
export * from "./DeliveryAreas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__